import {useConfig} from '../config';
import {BrowserCloseConfirmation} from '../types';

export const useBrowserCloseConfirmationConfig = () => {
    const [browserCloseConfirmation, setBrowserCloseConfirmation] = useConfig(
        'browserCloseConfirmation',
    );

    const [isEnableBrowserCloseConfirmationByDefault] = useConfig(
        'enableBrowserCloseConfirmationByDefault',
    );

    const shouldShowBrowserCloseConfirmation =
        (isEnableBrowserCloseConfirmationByDefault === true &&
            browserCloseConfirmation === BrowserCloseConfirmation.Unset) ||
        browserCloseConfirmation === BrowserCloseConfirmation.Enabled
            ? true
            : false;

    return {
        browserCloseConfirmation,
        setBrowserCloseConfirmation,
        shouldShowBrowserCloseConfirmation,
        isEnableBrowserCloseConfirmationByDefault,
    };
};
